function trimEnd(value?: string, character?: string) {
  if (!value) return '';
  if (value && character === undefined) {
    return value.trimRight();
  }
  if (!value || !character) {
    return value || '';
  }

  let trimmed = value;

  while (trimmed.charAt(trimmed.length - 1) === character) {
    trimmed = trimmed.substring(0, trimmed.length - 1);
  }

  return trimmed;
}

export default trimEnd;
